import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { Typeahead } from 'react-bootstrap-typeahead';
import { withRouter } from 'react-router-dom';
import { Mixpanel } from '../../redux/Mixpanel';

import {
    Container,
    Button,
    Row,
    Col,
    Form,
    FormFeedback,
    FormGroup,
    Input,
    InputGroup,
    UncontrolledTooltip,
} from 'reactstrap';
import { addSharp, trashBinSharp } from 'ionicons/icons';
import CustomInput from '../../components/CustomInput';
import { OCCUPANT_TYPE, colorTheme } from '../../utils/constants';
import {
    check_empty_field,
    check_if_number,
    check_date_field

} from './validationChecks';
import ShowMoreButton from './ShowMoreButton';
import CustomLabel from '../../components/CustomLabel';

import {
    addInvoice,
    updateInvoice,
    deleteInvoices,
    showLoading,
    showFeatureComingSoon,
    updateUnitUtility,
    fetchPropertyTenants,
    fetchSingleInvoice,
    fetchUser
} from '../../redux/actions';
import { fetchPropertiesUnitsTenants } from '../../redux/middleware';
import CustomPropertySelect from '../../components/CustomPropertySelect';
import { renderTenantSearchMenu } from '../../utils';
import * as PermChecker from '../../utils/PermUtils';
import dayjs from 'dayjs';
import {
    IonInput,
    IonText,
    IonIcon,
    IonButton
} from '@ionic/react';

const mapStateToProps = state => {
    return {
        properties: state.properties,
        units: state.units,
        tenants: state.tenants,
        invoices: state.invoices,
        options: state.options,
        unitUtilities: state.unitUtilities,
        user: state.user
    };
}

const mapDispatchToProps = {
    addInvoice,
    showLoading,
    updateInvoice,
    deleteInvoices,
    showFeatureComingSoon,
    updateUnitUtility,
    fetchSingleInvoice,
    fetchPropertyTenants,
    fetchUser
}

class InvoiceForm extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            tenant: [],
            tenantDetails: props.tenantDetails || (props.invoice && props.invoice.tenantDetails) || null,
            propertyId: props.tenantDetails? props.tenantDetails.propertyId : "",
            properties: [],
            amount: "",
            memo: "",
            invoiceItem: [],
            invoiceItems:[{ name: [], amount: "", description: "", autoDescription: ""}],
            invoiceStatus: [{id: 'open', label: 'open'}],
            invoiceId: "",
            invoiceDate: new Date().toISOString().split('T')[0],
            month: dayjs().format("MMMM"),
            dateFocused: false,
            utilityId:"",
            tenantOptions: [],
            invoiceOptions: [],
            initialInvoiceStatusOptions: [],
            invoiceItemOptions:[],
            invoiceStatusOptions: [],
            readOnly: false,
            combineWithOtherInvoices: true,
            errors: {
                amount: "",
                tenant: "",
                invoiceItem: "",
                invoiceItems: [{name: "", amount: "", description: ""}],
                invoiceStatus: "",
                memo: "",
                invoiceDate: ""
            },
            numErrors: 0

        };
    }

    getTenantOption(tenant){
        if (tenant){
            let label = "";
            if(tenant?.archived){
                label += "[Archived] - "
            }
            label += tenant.firstName + " " + tenant.lastName;
            if(tenant.propertyId in this.props.properties){
                label += " (" + this.props.properties[tenant.propertyId].propertyName

                if(tenant.unitId in this.props.units){
                    label += " : " + this.props.units[tenant.unitId].unitName
                }

                label += ")"
            }
            return {
                id: tenant.tenantId,
                tenantDetails: tenant,
                label
            };
        }{
            return null;
        }
    }

    getInvoiceItemOption = (invoiceItem) => ({id: invoiceItem, label: invoiceItem})

    getInvoiceItems = (item, index) => {
        return {
            name: [item.itemName],
            amount: item.amount,
            description: item.description,
            autoDescription: item.autoDescription
        }
    }

    getInvoiceStatus = (invoiceStatus) => ({id: invoiceStatus, label:invoiceStatus})

    async setTenantOptions(propertyId=""){
        let tenantOptions = [];

        if(propertyId){
            this.props.showLoading(true);
            const action = await this.props.fetchPropertyTenants({propertyIds:[propertyId]});
            if(action && action.payload && action.payload.tenants){
                for(let tenant of Object.values(action.payload.tenants)){
                    if(!tenant.archived){
                        tenantOptions.push(this.getTenantOption(tenant));
                    }
                }
            }
        }
        let selectedTenant = this.getTenantOption(this.state.tenantDetails);
        this.setState({
            tenantOptions,
            tenant: selectedTenant? [selectedTenant] : []
        });
    }

    fetchInitialData = async () => {
        try {
            await Promise.all([
                (async () => {
                    if (_.isEmpty(this.props.user)) {
                        await this.props.fetchUser();
                    }
                })(),
                (async () => {
                    if (_.isEmpty(this.props.properties)) {
                        await store.dispatch(fetchPropertiesUnitsTenants);
                    }
                })(),
            ]);
        } catch (error) {
            console.error("Error fetching initial data:", error);
        }
    }

    async componentDidMount() {
        await this.fetchInitialData();

        const hasAllInvoicePerm = PermChecker.checkUserHasPermission(
            PermChecker.INVOICE_MODEL,
            PermChecker.ALL_PERM,
            this.props.options?.userPermissions
        );
        let newState = {};

        if (this.state.tenantDetails) {
            await this.setTenantOptions(this.state.tenantDetails.propertyId);
        } else {
            const propertyIds = Object.keys(this.props.properties);
            if (propertyIds.length === 1) {
                newState.propertyId = propertyIds[0];
                await this.setTenantOptions(propertyIds[0]);
            }
        }

        newState = {
            ...newState,
            initialInvoiceStatusOptions: ["open", "draft", "credit-note"].map(this.getInvoiceStatus),
            invoiceItemOptions: this.props.options.invoiceItems,
            properties: Object.values(this.props.properties)
        };

        if (this.props.invoiceId || this.props.invoice) {
            let invoice = this.props.invoiceId ? null : this.props.invoice;
            if (!invoice && this.props.invoiceId) {
                this.props.showLoading(true);
                await this.props.fetchSingleInvoice(this.props.invoiceId);
                invoice = this.props.invoices[this.props.invoiceId];
            }

            let propertyId;
            let tenantDetails;
            let invoiceDate;
            if (this.props.invoiceId) {
                propertyId = invoice.tenant.propertyId;
                tenantDetails = invoice.tenant;
                invoiceDate = invoice.invoiceDate || "";
            } else if (this.props.invoice) {
                propertyId = invoice.propertyId;
                tenantDetails = invoice.tenantDetails || invoice.tenant;
                invoiceDate = dayjs(invoice.invoiceDate) || "";
            } else {
                propertyId = "";
                tenantDetails = null;
            }

            const invoiceItems = invoice.invoiceItems.map(this.getInvoiceItems.bind(this));
            newState = {
                ...newState,
                readOnly: !hasAllInvoicePerm,
                amount: invoice.amount,
                combineWithOtherInvoices: invoice.combineWithOtherInvoices,
                memo: this.props.invoice ? invoice.memo : invoice.description,
                invoiceItem: [this.getInvoiceItemOption(invoice.item)],
                invoiceStatus: [this.getInvoiceStatus(invoice.status.toLowerCase())],
                invoiceId: this.props.invoiceId ? this.props.invoiceId : this.state.invoiceId,
                invoiceDate: invoiceDate.toISOString().split('T')[0],
                month: this.props.invoiceId ? (invoice.invoiceDate ? dayjs(invoice.invoiceDate).format("MMMM") : "") : (invoiceDate ? dayjs(invoiceDate).format("MMMM") : ""),
                utilityId: this.props.invoice ? invoice.utilityId : "",
                tenantDetails: tenantDetails,
                propertyId: propertyId,
                showOptionalFields: true,
                invoiceItems,
                invoiceItemOptions: this.getInvoiceItemOptions(invoiceItems),
                errors: {
                    ...this.state.errors,
                    invoiceItems: invoiceItems.map((item) => ({ name: "", amount: "", description: "" }))
                }
            };

            await this.setTenantOptions(propertyId);
        }

        this.setState(newState);
    }

    async validateInput(name, value){
        let val = value;
        if (!Array.isArray(value) && val !== null){
            val = String(value);
        }
        let isValid = true;
        let checks = [];

        switch(name){
            case "tenant":
                checks = [check_empty_field];
                break;
            case "invoiceItems":
                checks = [check_empty_field];
                break;
            case "invoiceStatus":
                checks = [check_empty_field];
                break;
            case "invoiceDate":
                checks = [check_date_field];
                break;
            default:
                break;
        }

        await this.setState((prevState) => {
            let errors = {...prevState.errors};
            let numErrors = prevState.numErrors;
            for (let index in checks){
                let previousError = prevState.errors[name];
                errors[name] = checks[index](val);

                if (errors[name].length > 0){
                    if (previousError.length == 0){
                        numErrors += 1
                    }
                    isValid = false;
                    break;
                }else if(previousError.length > 0){
                    numErrors -= 1
                }
            }
            return {
               errors,
               numErrors
            };
        });
        return isValid;
    }

    handleChange(event){
        event.preventDefault();
        let target = event.target;
        let name = target.name;
        let val = target.type === 'checkbox' ? target.checked : target.value;
        this.setState({[name]: val});
        this.validateInput(name, val);
    }

    async handleChangedOptions(name, selected){
        this.setState({[name]: selected});
        this.validateInput(name, selected);
    }

    async handleSubmit(event){
        event.preventDefault();
        let fields = ["tenant", "invoiceStatus", "invoiceDate"];
        let results = [];
        for(let field of fields){
            let isValid = await this.validateInput(field, this.state[field])
            results.push(isValid);
        }
        let invalid_fields = results.filter( (x) => !x);
        const isValidInvoiceItems = this.isValidInvoiceItems();
        if(invalid_fields.length == 0 && isValidInvoiceItems){
            let tenantInvoice = {
                tenantId: this.state.tenant[0].tenantDetails.tenantId,
                memo: this.state.memo,
                invoiceItems: this.state.invoiceItems,
                status: this.state.invoiceStatus[0].id,
                invoiceDate: this.state.invoiceDate? this.state.invoiceDate.slice(0, 10) : "",
                combineWithOtherInvoices: this.state.combineWithOtherInvoices
            };
            this.props.showLoading(true);
            let result;
            if(this.state.invoiceId == ""){
                result = await this.props.addInvoice(tenantInvoice);
            }else{
                tenantInvoice["invoiceId"] = this.state.invoiceId;
                result = await this.props.updateInvoice(tenantInvoice);
            }
            if(result && !result.errors && result.payload &&
                result.payload.invoice && result.payload.invoice.invoiceId
            ){
                let invoice = result.payload.invoice;
                this.setState({
                    invoiceId: invoice.invoiceId,
                    invoiceItems: invoice.invoiceItems.map(this.getInvoiceItems.bind(this)),
                    readOnly: !PermChecker.checkUserHasPermission(
                        PermChecker.INVOICE_MODEL,
                        PermChecker.ALL_PERM,
                        this.props.options?.userPermissions
                    ),
                    errors: {
                        ...this.state.errors,
                        invoiceItems: invoice.invoiceItems.map((item) => ({name: "", amount: "", description: ""}))
                    }
                })
            }
        }
    }

    async handleConfirmInvoice(event){
        event.preventDefault();
        let invoice = {
            tenantId: this.state.tenant[0].tenantDetails.tenantId,
            memo: this.state.memo,
            invoiceItems: this.state.invoiceItems,
            status: this.state.invoiceStatus[0].id,
            invoiceDate: this.state.invoiceDate? this.state.invoiceDate: "",
            combineWithOtherInvoices: this.state.combineWithOtherInvoices
        };

        this.props.showLoading(true);
        let result = await this.props.addInvoice(invoice, false); //If false, invoice wont be added to the invoicesOrder list. Default is false
        //to do: combine addInvoice and updateUnitUtility
        if(!result.errors && result && result.payload && result.payload.invoice){
            let inv = result.payload.invoice;
            this.props.showLoading(true);
            let utilityId = this.props.invoice.utilityId;
            await this.props.updateUnitUtility({
                utilityId: utilityId,
                unitId: this.props.unitUtilities[utilityId].unit,
                date: this.props.unitUtilities[utilityId].date ? this.props.unitUtilities[utilityId].date : "",
                item: this.props.unitUtilities[utilityId].item,
                currentReading: this.props.unitUtilities[utilityId].currentReading,
                previousReading: this.props.unitUtilities[utilityId].previousReading,
                invoiceId: inv.invoiceId
            });
            this.setState({
                invoiceId: inv.invoiceId,
                invoiceItems: inv.invoiceItems.map(this.getInvoiceItems.bind(this)),
                errors: {
                    ...this.state.errors,
                    invoiceItems: inv.invoiceItems.map((item) => ({name: "", amount: "", description: ""}))
                }
            })

        }
        Mixpanel.track("Invoice form: confirm btn");
    }

    handleDelete(event){
        event.preventDefault();
        if(confirm("Are you sure you want to delete this invoice?")){
            this.props.showLoading(true);
            this.props.deleteInvoices([this.state.invoiceId]);
            this.setInvoiceValues();
            Mixpanel.track("Invoice form: delete btn");
        }

    }

    handleClear(event){
        event.preventDefault();
        this.setInvoiceValues();
        Mixpanel.track("Invoice form: clear btn");
    }

    setInvoiceValues(invoiceId="", propertyId="", tenant=[], amount="", memo="", invoiceDate=null, readOnly=false, invoiceItem=[], invoiceItems=[{ name: [], amount: "", description: "", autoDescription: ""}]){
        this.setState({
            invoiceId, propertyId, tenant, readOnly,
            amount, memo, invoiceItem,invoiceItems,
            invoiceDate,

        });

    }

    onClickUploadSpreadSheet(event){
        event.preventDefault();
        this.props.showFeatureComingSoon();
        Mixpanel.track("Invoice form: upload spreadsheet btn");
    }

    async handleSelectProperty(event){
        event.preventDefault();
        let value = event.target.value;
        this.setState((prevState) => {
            let { propertyId } = prevState;
            if (propertyId != value){
                this.setTenantOptions(value);
                propertyId = value;
            }
            return {
                propertyId,
                tenantDetails: null,
                tenant: []

            };
        });
    }

    handleChangeInvoiceItem(index, key, event){
        event.preventDefault();
        this.setState((prevState) => {
            let {invoiceItems} = prevState;
            invoiceItems[index][key] = event.target.value;
            return {invoiceItems}
        });
        this.isValidInvoiceItems();
    }

    getInvoiceItemOptions(invoiceItems){
        let alreadySelected = [];
        for(let item of invoiceItems){
            if(item.name.length > 0){
                alreadySelected.push(item.name[0]);
            }
        }
        const invoiceItemOptions = this.props.options.invoiceItems.filter(itemName => !alreadySelected.includes(itemName));
        return invoiceItemOptions;
    }

    handleChangedInvoiceItemOptions(index, selected){
        this.setState((prevState) => {
            let {invoiceItems} = prevState;
            invoiceItems[index]["name"] = selected;
            return {invoiceItems, invoiceItemOptions: this.getInvoiceItemOptions(invoiceItems)};
        });
        this.isValidInvoiceItems();
    }

    isValidInvoiceItems(){
        let foundError = false;
        this.setState(prevState => {
            const invoiceItems = prevState.invoiceItems.map((item, index) => {
                let nameError = "";
                let amountError = "";
                if(index == 0 || !(item.name.length == 0 && item.amount.length == 0)){
                    nameError = check_empty_field(item.name);
                    amountError = check_empty_field(item.amount) || check_if_number(item.amount.toString());
                }
                if(!foundError){
                    foundError = nameError.length > 0 || amountError.length > 0;
                }
                return {
                    name: nameError,
                    amount: amountError,
                    description: "",
                    distribution: ""
                };
            });
            return {
                errors: {
                    ...prevState.errors,
                    invoiceItems
                }
            }
        });
        return !foundError;
    }

    renderRequiredFields(){
        return (
            <React.Fragment>
                {/* Select Tenant */}
                <FormGroup row>
                    <CustomLabel
                        sm={12} md={3}
                        for="propertyId">
                            Select {this.props.options.userAccountType === OCCUPANT_TYPE ? "Tenant" : "Member"}
                    </CustomLabel>

                    <Col sm={12} md={8} className="">
                        <Row>
                            <Row>
                            <Col style={{maxWidth: '450px'}} xs={12} sm={12} lg={12}>
                                <CustomInput
                                    type="select"
                                    id="propertyId"
                                    name="propertyId"
                                    className="mr-2"
                                    disabled={this.state.readOnly}
                                    onChange={this.handleSelectProperty.bind(this)}
                                    value={this.state.propertyId}
                                >
                                    <CustomPropertySelect propertiesArray={this.props.properties}/>
                                </CustomInput>
                            </Col>
                            </Row>

                            <Row>
                            <Col id='tenantInvoice' className="mt-2" style={{maxWidth: '450px'}} lg={12} xs={12} sm={12}>
                                <Typeahead
                                    emptyLabel={this.state.propertyId==="" ? `Please first select ${this.props.options.userAccountType === OCCUPANT_TYPE ? "tenant" : "member"} property.` : `Choose ${this.props.options.userAccountType === OCCUPANT_TYPE ? "tenant" : "member"}. No matches found.`}
                                    placeholder={`Select ${this.props.options.userAccountType === OCCUPANT_TYPE ? "tenant(s)" : "member(s)"} ...`}
                                    disabled={this.state.readOnly}
                                    id="tenant"
                                    clearButton
                                    options={this.state.tenantOptions}
                                    name="tenant"
                                    selected={this.state.tenant}
                                    paginate={false}
                                    maxResults={10000000}  // chose a high number because we don't want to handle pagination. Just show all results.
                                    onChange={this.handleChangedOptions.bind(this, "tenant")}
                                    renderMenu={renderTenantSearchMenu}
                                >
                                </Typeahead>
                                {this.state.errors.tenant.length > 0 && <p className="text-danger">
                                    {this.state.errors.tenant}
                                </p>}
                            </Col>
                            </Row>

                        </Row>
                    </Col>
                </FormGroup>

                {/* Invoice Item */}
                <FormGroup row>
                    <CustomLabel sm={12} md={3} for="invoiceItem">
                            Invoice Item(s)
                    </CustomLabel>

                    <Col style={{minWidth:'300px', maxWidth: '450px'}} sm={12} md={8}>
                        {this.state.invoiceItems.map( (item, index) => (
                            <Row id={index.toString()} className='mt-3 mb-2' key={index.toString()}>
                                <Col>
                                    <Row>
                                        <Col id={'invoiceItemContainer' + index.toString()} className='my-1' style={{minWidth:'200px'}}>
                                            <Typeahead
                                                clearButton
                                                disabled={this.state.readOnly}
                                                id={"invoiceItem" + index.toString()}
                                                options={this.state.invoiceItemOptions}
                                                name="invoiceItem"
                                                placeholder="item name"
                                                selected={item.name}
                                                onChange={this.handleChangedInvoiceItemOptions.bind(this, index)}
                                            >
                                            </Typeahead>
                                            {this.state.errors.invoiceItems[index].name.length > 0 &&
                                                <p className="text-danger">{this.state.errors.invoiceItems[index].name}</p>
                                            }
                                        </Col>

                                        <Col className='my-1' style={{minWidth:'200px'}}>
                                            <InputGroup>
                                                <Input
                                                    readOnly={this.props.fromUtilities ? false : this.state.readOnly}
                                                    id={"amount" + index.toString()}
                                                    name="amount"
                                                    placeholder='amount'
                                                    value={item.amount}
                                                    onChange={this.handleChangeInvoiceItem.bind(this, index, "amount")}
                                                    invalid={this.state.errors.invoiceItems[index].amount.length > 0}
                                                />
                                                <FormFeedback>{this.state.errors.invoiceItems[index].amount}</FormFeedback>
                                            </InputGroup>
                                        </Col>

                                        <Col className='mt-2 mr-3'  style={{minWidth: '300px'}}>
                                            <InputGroup>
                                                <Input
                                                    readOnly={this.props.fromUtilities ? false : this.state.readOnly}
                                                    id={"description" + index.toString()}
                                                    name="description"
                                                    placeholder='description'
                                                    type="textarea"
                                                    value={item.description}
                                                    onChange={this.handleChangeInvoiceItem.bind(this, index, "description")}
                                                    invalid={this.state.errors.invoiceItems[index].description.length > 0}
                                                />
                                                <FormFeedback>{this.state.errors.invoiceItems[index].description}</FormFeedback>
                                            </InputGroup>
                                        </Col>
                                    </Row>
                                </Col>

                                {(this.state.invoiceItems.length-1) == index && (
                                    // Button to add More Inoice Items
                                    <Col className='d-flex align-items-end mt-1 mx-1 mr-2' style={{maxWidth:'50px'}}>
                                        <Button
                                            outline color="secondary"
                                            disabled={this.state.readOnly}
                                            id={'addInvoiceItem' + index.toString()}
                                            onClick={() => {
                                                this.setState((prevState) => ({
                                                    invoiceItems: [...prevState.invoiceItems, {name: [], amount: "", description: ""}],
                                                    errors: {
                                                        ...prevState.errors,
                                                        invoiceItems: [
                                                            ...prevState.errors.invoiceItems,
                                                            {name: "", amount: "", description: ""}
                                                        ]
                                                    }
                                                }))
                                            }}
                                        >
                                        <IonIcon size="2x" icon={addSharp} />
                                    </Button>
                                </Col>)}
                                {this.state.invoiceItems.length > 1 &&
                                    (<Col className='d-flex align-items-end mt-1 mx-1 mr-2' style={{maxWidth:'50px'}}>
                                        <Button
                                            id={'removeInvoiceItem' + index.toString()}
                                            outline color="secondary"
                                            disabled={this.state.readOnly}
                                            onClick={() => {
                                                this.setState((prevState) => ({
                                                    invoiceItems: prevState.invoiceItems.filter( (item, itemIndex) => itemIndex != index),
                                                    errors: {
                                                        ...prevState.errors,
                                                        invoiceItems: prevState.errors.invoiceItems.filter( (item, itemIndex) => itemIndex != index)
                                                    }
                                                }))
                                            }}
                                        >
                                        <IonIcon size="2x" icon={trashBinSharp} />
                                    </Button>
                                </Col>
                                )}
                            </Row>
                        ))}


                    </Col>
                </FormGroup>

                {/* Date */}
                <FormGroup row>
                    <CustomLabel sm={12} md={3} for="invoiceDate">
                        Invoice Date
                    </CustomLabel>

                    <Col style={{minWidth: '200px', maxWidth: '250px'}} sm={12} md={8}>
                        <IonInput
                            id='invoiceDate'
                            type='date'
                            fill='solid'
                            value={this.state.invoiceDate}
                            onIonChange={event => {
                                const invoiceDate = event.detail.value;
                                this.setState({ invoiceDate })
                                this.validateInput("invoiceDate", invoiceDate)
                            }}
                        />
                        {this.state.errors.invoiceDate.length > 0 && <p className="text-danger">{this.state.errors.invoiceDate}</p>}
                    </Col>
                </FormGroup>

                {/* Status */}
                <FormGroup row>
                    <CustomLabel  sm={12} md={3} for="paymentType">
                        Invoice Status
                        <i id="invoiceStatus" className="fa fa-fw fa-info-circle ml-2"></i>
                    </CustomLabel>

                    <UncontrolledTooltip placement="top" target="invoiceStatus">
                        <p>Draft - an invoice whose details, such as amount, CAN be changed.</p>
                        <p>Open - invoice whose details such as amount CANNOT be changed.</p>
                        <p>Note: Invoice in draft status cannot be sent to {this.props.options.userAccountType === OCCUPANT_TYPE ? "tenants" : "members"}. However, invoices in open status can be sent to {this.props.options.userAccountType === OCCUPANT_TYPE ? "tenants" : "members"}.</p>
                    </UncontrolledTooltip>

                    <Col id='statusInputContainer' style={{minWidth: '200px', maxWidth: '250px'}} sm={12} md={8}>
                        <Typeahead
                            clearButton
                            disabled={this.state.readOnly}
                            id="statusInput"
                            options={this.state.initialInvoiceStatusOptions}
                            name="invoiceStatus"
                            selected={this.state.invoiceStatus}
                            onChange={this.handleChangedOptions.bind(this, "invoiceStatus")}
                        >
                        </Typeahead>
                        {this.state.errors.invoiceStatus.length > 0 && <p className="text-danger">{this.state.errors.invoiceStatus}</p>}
                    </Col>
                </FormGroup>

                <FormGroup row>
                    <CustomLabel sm={12} md={3}>
                    </CustomLabel>
                    <Col style={{maxWidth: '450px'}} sm={12} md={8}>
                            <CustomInput
                                type="checkbox"
                                id="combineWithOtherInvoices"
                                name="combineWithOtherInvoices"
                                value={this.state.combineWithOtherInvoices}
                                checked={this.state.combineWithOtherInvoices}
                                onChange={(e) => {
                                    this.setState({
                                        combineWithOtherInvoices: e.target.checked
                                    });
                                }}
                                label="Combine with Other Invoices"
                            />
                        {this.state.month && (<p>
                            If checked then this invoice will be combined with other {this.state.month} invoices for this {this.props.options.userAccountType === OCCUPANT_TYPE ? "tenant" : "member"}.
                        </p>)}
                    </Col>
                </FormGroup>
            </React.Fragment>
        );
    }

    renderOptionalFields(){
        return (
            <React.Fragment>
                {/* Memo */}
                <FormGroup row>
                    <CustomLabel sm={12} md={3}  for={"memo"}>
                        Memo (optional) <i id="memoInfo" className="fa fa-fw fa-info-circle ml-2"></i>
                    </CustomLabel>
                    <UncontrolledTooltip placement="top" target="memoInfo">
                        <p>Any other details, for example preferred payment method.</p>
                    </UncontrolledTooltip>

                    <Col style={{maxWidth: '450px'}} sm={12} md={8}>
                        <InputGroup>
                            <Input
                                readOnly={this.state.readOnly}
                                id="memo"
                                name="memo"
                                type="textarea"
                                value={this.state.memo}
                                onChange={this.handleChange.bind(this)}
                                invalid={this.state.errors.memo.length > 0}
                            />
                            <FormFeedback>{this.state.errors.memo}</FormFeedback>
                        </InputGroup>
                    </Col>
                </FormGroup>
            </React.Fragment>
        );
    }

    renderButtons(){
        return (
            <Row className="d-flex mb-4 pb-3 border-bottom border-dark justify-content-center">
                {(this.props.fromUtilities==true && this.state.invoiceId=="") && (
                    <IonButton type="submit"
                        className="shadow py-1"
                        id="confirmInvoiceButton"
                        onClick={this.handleConfirmInvoice.bind(this)}
                    >
                        Confirm Invoice
                    </IonButton>
                )}

                {(!this.props.fromUtilities || this.state.invoiceId != "") && (
                        <IonButton type="submit"
                            onClick={this.handleSubmit.bind(this)}
                            className="shadow py-1"
                            style={{ width: "80%" }}
                            id="saveBtn"
                            disabled={this.state.numErrors > 0 || this.state.readOnly}>
                            {this.state.invoiceId?
                                <span><i className="fa fa-fw fa-refresh mr-1"></i>Update Invoice</span>:
                                <span><i className="fa fa-fw fa-plus mr-1"></i>Add Invoice</span>
                            }
                        </IonButton>
                )}

                {(!this.props.fromUtilities && this.state.invoiceId != "") && (
                    <IonButton type="submit"
                        className="mt-3 py-1"
                        style={{ width: "80%" }}
                        id="clearButton"
                        onClick={this.handleClear.bind(this)}
                        fill='outline'
                        >
                            <span><i className="fa fa-fw fa-plus mr-1"></i>Add Another Invoice</span>
                    </IonButton>
                )}
            </Row>

        );
    }
    render(){
        return (
            <React.Fragment>

            <Container>
                <Row className="mb-4">
                    <Col style={{minWidth:'300px'}} lg={9} md={8} sm={7} xs={6}>
                        <IonText>Use this form to create {this.props.options.userAccountType === OCCUPANT_TYPE ? "tenant" : "member"} invoices.</IonText>
                    </Col>

                    <Col lg={3} md={4} sm={5} xs={6}>
                        {this.state.invoiceId && (<IonButton
                            size="lg"
                            color="secondary"
                            className="mx-2 shadow"
                            id="deleteButton"
                            onClick={this.handleDelete.bind(this)}
                            disabled={this.state.readOnly}
                            data-testid="deleteButton"
                        >
                        <IonIcon size="2x" icon={trashBinSharp} />
                        </IonButton>)}
                    </Col>
                </Row>
                <Row>
                    <Col lg={12}>
                        {this.state.readOnly && (<Row className="my-2">
                            <Col lg={12}>
                                {this.state.invoiceStatus[0] && (
                                <h6 style={{color:'red'}} >
                                    Invoice in {this.state.invoiceStatus[0].id} status is read only
                                </h6>)}
                            </Col>
                        </Row>)}

                        {this.renderRequiredFields()}

                        <ShowMoreButton
                            id="showOptionalFields"
                            onClick={(e) => {
                                e.preventDefault();
                                this.setState((prevState) => ({showOptionalFields: !prevState.showOptionalFields}))
                            }}
                            showMore={this.state.showOptionalFields}
                        />

                        {this.state.showOptionalFields && this.renderOptionalFields()}


                        {this.renderButtons()}

                    </Col>
                </Row>
        </Container>
        </React.Fragment>);
    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(InvoiceForm));